<template>
  <el-container>
    <el-header>
      <headerNav />
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-footer><footBottom /></el-footer>
  </el-container>
</template>

<script>
import headerNav from '@/components/headerNav.vue';
import footBottom from '@/components/footBottom.vue';

export default {
  name: 'home',
  components: { headerNav, footBottom },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/ .el-header {
  height: auto !important;
  padding: 0;
}
/deep/ .el-main {
  min-height: calc(100vh - 235px) !important;
  padding: 0;
  // background: url('@/assets/images/bg.png') repeat-y;
  background-size: 100% auto;
  position: relative;
  display: flex;
  flex-direction: column;
}
/deep/ .el-footer {
  height: 165px !important;
  padding: 0;
}
</style>
